module.exports = __webpack_public_path__ + "img/more_circle.26877b04.svg";